// src/constants.js
export const API_URL ="https://delivery-abm.bppp.kemendikdasmen.go.id/api-v2/services";
// export const API_URL ="http://localhost:5050/api-v2/services";
export const API_URL_REDIS ="https://delivery-abm.bppp.kemendikdasmen.go.id/api-v2";
// export const API_URL_REDIS ="http://localhost:5050/api-v2";
export const API_URL2 ="https://delivery-abm.bppp.kemendikdasmen.go.id/api-v2/services2";
export const API_URL_LOGIN ="https://delivery-abm.bppp.kemendikdasmen.go.id/api-v2/services";
// export const API_URL_LOGIN ="http://localhost:5052/api-v2/services";
export const PENGAWAS_API_URL="https://pengawas-ujian.bppp.kemendikdasmen.go.id/v1/dashboard-pengawas-service";
export const API_URL_PHOTO ="https://delivery-abm.bppp.kemendikdasmen.go.id/api-image-v2/services";
// export const API_URL_PHOTO ="http://localhost:5051/api-image-v2/services";
export const API_URL_SAVE_ANSWER ="https://delivery-abm.bppp.kemendikdasmen.go.id/api-v2/services";
// export const API_URL_SAVE_ANSWER ="http://localhost:5050/api-v2/services";
export const API_URL_LOG ="https://delivery-abm.bppp.kemendikdasmen.go.id/api-image-v2/services";
// export const API_URL_LOG = "http://localhost:5051/api-image-v2/services";
export const SECRET_KEY = "HO1I2HU34129431-312IJH1U2";
export const SECRET_SESSION = "189273198273AKJ3LA3JJJ234234SEFA";
export const BUILD_VERSION = "2.1.2";